<div class="flex align-items-center justify-content-between mb-4">
  <div>
    <h1 class="text-3xl font-bold text-900 m-0">{{ title }}</h1>
    <p *ngIf="subtitle" class="text-500 mt-1 mb-0">{{ subtitle }}</p>
  </div>
  <div class="flex gap-2">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
